// import { opacity } from "html2canvas/dist/types/css/property-descriptors/opacity";
import { render } from "@testing-library/react";
import React from "react";
import moment from "moment";
import FixedView from "../../FixedView";
import TasksCalendar from "../../../windows/Desk/Eagleviews/tasksCalendar";
import Modal from "../../Modal";
import FormViewer from "../../FormViewer";
import TextInput from "../../inputs/TextInput";
import SidebarView from "../../SidebarView";
import { getObject, setObject, translate } from "../../../utils/useful";
// const NewColumnItem = ({ addNewItem, columnid,newTask,setNewTask }) => {
class NewColumnItem extends React.Component {
    constructor(props) {
        super(props)
        this.inputRef = React.createRef();
        this.newBoxRef = React.createRef();
        this.calendarPicker = React.createRef();
        this.calendarNode = React.createRef();
        this.state = {
            data: {},
            Priority: "low",
            showCalendarPicker: false,
            // time: [

            //     { name: "Today", date: moment().format('ddd') },
            //     { name: "Later", date: moment().add(6, 'hours').format("h:mm") },
            //     { name: "Tomorrow", date: moment().add(1, 'days').format("ddd") },
            //     { name: "Next Week", date: moment().add(1, 'week').format("ddd") },
            //     { name: "Next Weekend", date: "sat" },
            //     { name: "2 Weeks", date: moment().add(2, 'weeks').format("MMM DD") },
            //     { name: "4 Weeks", date: moment().add(4, 'weeks').format("MMM DD") },
            //     { name: "8 Weeks", date: moment().add(8, 'weeks').format("MMM DD") },
            // ]
        }

    }
    // const[Priority, setPriority] = useState("low");

    // setData = () => {
    //     let data = this.state.data ?? {}
    //     data.form = this.form.getForm()
    //     let [key, value] = Object.entries(this.formName.getForm())[0]
    //     data[key] = value
    //     console.log('dataform==', data)
    //     this.setState({ data })
    //     this.props.addNewItem(this.props.columnid, data, key);
    //     this.props.setNewTask((prev) => !prev);
    //     this.newModal.close()

    // }


    addRecord = () => {

        let newData = {}
        // let key = this.props.column?.headerInfo?.headerKey
        // key = key.replace('values.', '')
        // console.log('keyobject', key)
        setObject(newData, this.props.column?.headerInfo?.headerKey, this.props.column?.columnHeader)
        // console.log('newData', newData)
        // console.log('this.props.column?.headerInfo?.value', this.props.column)
        this.props.functionsHandler('collection', 'addRecord', newData)
    }


    render() {
        let headers = this.props.headers
        headers?.forEach(header => {
            if (!header.information) {
                header.information = {}
            }
            header.information.col = 12
            header.col = 12
        })

        // console.log(this.props.column)
        return (
            <div>
                {(!this.props.newTask || true) &&
                    <div className="newItem ">
                        <button className="flexc br-10 px-2 py-2 w-100" onClick={() => this.addRecord()} style={{ backgroundColor: '#fff', boxShadow: '0px 0px 10px #10101010', border: '1px solid #f0f0f0' }}>
                            <img width={16} src="/assets/icons/plus-black.svg" />
                            <p className="font-size-13 "> {translate("Add Item")}</p>
                        </button>
                    </div>
                }
                {/* <Modal ref={el => this.newModal = el} maxWidth={500}> */}
                {/* <SidebarView updatePos widthImport={450} ref={e => this.newModal = e}>
                    <div className="mb-2" style={{ background: '#fff', borderRadius: "8px" }}>
                        <div className="mt-2">
                            <FormViewer ref={el => this.formName = el} headers={[{ type: "TextInput", key: 'taskName', label: 'Task Name', information: { label: 'Task Name', placeholder: 'Enter Task Name', required: true } }]} />
                        </div>
                        <div className=" d-flex flex-column flex align-items-center px-2 pt-2" style={{ borderTop: '1px solid #d0d0d0ac' }}>
                            <p>Fields</p>
                            <FormViewer ref={el => this.form = el} headers={headers} formClass={''} />
                            <button onClick={() => this.setData(true)} className='px-1 py-1  flexcb ' style={{
                                // background: "#bdc3c7",
                                // background: "-webkit-linear-gradient(to right, rgb(229,46,77), #bdc3c7)",
                                background: " linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))", borderRadius: 8, color: '#fff', transition: 'all 0.5s', boxShadow: '0px 0px 10px #10101030'
                            }}>
                                <p className='text-small text-semibold mld-3 mrd-3 ' style={{ whiteSpace: 'nowrap' }}>Submite</p>
                            </button>
                        </div>

                    </div>
                </SidebarView> */}
                {/* </Modal> */}
            </div>
        );


        // if (this.props.newTask && false) {
        //     return (
        //         <div className="nexItemBox" ref={this.newBoxRef}>
        //             <div className="newItem-InputHolder">
        //                 <div className="input">
        //                     <img src="/assets/icons/multiply-red.svg" width={20} onClick={() => this.props.setNewTask((prev) => !prev)} />
        //                     <input onClick={() => console.log("first")} ref={this.inputRef} placeholder="Task name or type ..." type="text"
        //                     />
        //                 </div>

        //                 <span >
        //                     <img className="user-icon" src="/assets/icons/kanban/person.crop.circle.svg" />
        //                 </span>
        //             </div>
        //             <div className="save-holder">
        //                 <div>
        //                     <button className="px-2">
        //                         <img src="/assets/icons/bookmark-black.svg" alt="bookmark" />
        //                     </button>
        //                     <button className="px-2">
        //                         <img src="/assets/icons/paperclip-black.svg" alt="bookmark" />
        //                     </button>
        //                     <button className="px-2" ref={e => this.calendarNode = e} onClick={() => this.calendarPicker.showView()}>
        //                         <img src="/assets/icons/calendar-black.svg" alt="calendar" />
        //                     </button>
        //                     <button className="px-2">
        //                         <img src="/assets/icons/alarm-black.svg" alt="bookmark" />
        //                     </button>
        //                 </div>
        //                 <button className="" onClick={() => this.addItem(this.props.columnid, this.inputRef.current.value)}>
        //                     save
        //                 </button>
        //             </div>
        //             <FixedView zIndex={100} ref={el => this.calendarPicker = el} showFocus={false} nodeRef={this.calendarNode} xOffset={-20} topOffset={0} maxWidth={320}>
        //                 <div className='calendar-picker' style={{
        //                     top: "50%",
        //                     left: "19%"
        //                 }}>
        //                     <div className='Date'>
        //                         <input placeholder='Start date' ref={this.startDate}
        //                             type="search" className="input" variant="outlined" label="Search"
        //                             onChange={() => this.handleChangeDate()}
        //                             value={this.state.startDate} />
        //                         <input placeholder='Due date' ref={this.dueDate}
        //                             type="search" className="input" variant="outlined" label="Search"
        //                             onChange={() => this.handleChangeDate()}
        //                             value={this.state.dueDate}
        //                         />

        //                     </div>
        //                     <div className='calendar-part'>
        //                         <div className='left-calendar-part'>

        //                             {this.state.time.map((item, index) => {
        //                                 return (
        //                                     <div key={index} className="time-list" style={{ cursor: 'pointer', padding: '5px 11px', color: "gray" }}
        //                                         onClick={() => this.handleChangeDate(item)}>
        //                                         <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}
        //                                         ><b>{item.name}</b>{item.date}</div>
        //                                     </div>
        //                                 )
        //                             })}
        //                             <div className='set-recurring'
        //                             >
        //                                 <img src='/assets/icons/applets/desk/control.svg' />
        //                                 Set Recurring</div>
        //                         </div>
        //                         <div className='monthly-calendar'>
        //                             <TasksCalendar />
        //                         </div>
        //                     </div>
        //                     <div className='close-btn'
        //                     >Close</div>

        //                 </div>
        //             </FixedView>
        //         </div>
        //     );
        // }
    }
}

export default NewColumnItem;
